import React from 'react';

const AppLogo = ({ className = 'h-8 w-auto' }) => (
  <img src="/favicon.png" alt="MatchImovel" className={className} />
);

export default AppLogo;
